module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAaCAMAAACAXYxPAAAAQlBMVEVHcEwqj/kojvcwkfgljfIukPkwkPgrjvcwkvosj/ksj/g0kvkljPf////s9f6t0/w/mfnO5f1xtPrh7/2TxftbqPlCTgolAAAACnRSTlMA6v//GKRzgE2az1W5iwAAALdJREFUKM9tkFkOwyAQQwkT2ggwW+D+V+2wtA0J84HQk43NCLG/3r85RJ/DWsmj65AZdOuwUSLq1F6VNLR2VnbtHRrzWigrXUBzD6rsCa9KeVfGk6QO5xmIzzigQ5IyA5kowQ3o4aWMQCTi64AFTgc4h0Bs+gY5lATvkUpzd+iRmTDPzd1hQWQvvxCR/j0dp2jNWc3dIecja82t/OVHtbnm5i6svmmmhcyrkyuonvtUYlfbDDe1fwAqYhFuTeb1VAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/online_service/word.png
// module id = F4mE
// module chunks = 1